import { initializeStore } from '@seamless/store';
import { AEMComponentPrefill, initializeComponentRegistry } from '@owc/component-registry-connection';
import {
  addConnectionAemEnvironmentConnection,
  connectionName as aemEnvironmentConnectionName,
} from '@owc/connection-aem-environment';

/**
 * Read AEM dialogs
 * @param componentId
 */
/* istanbul ignore next */
export async function getAemComponentData(componentId: string | null): Promise<AEMComponentPrefill> {
  return new Promise((resolve) => {
    if (componentId) {
      const store = initializeComponentRegistry();

      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
      const listener = (state: Record<string, unknown>) => {
        resolve(state as AEMComponentPrefill);
        store.unsubscribe(componentId, listener);
      };

      store.subscribe(componentId, listener);
    }
  });
}

/* istanbul ignore next */
export const getAemEnvironmentVariables = (): Promise<{
  language: string;
  country: string;
  stage: string;
  assetUri: string;
  runMode: 'AUTHOR' | 'PUBLISH';
}> =>
  new Promise((resolve) => {
    const store = initializeStore();
    addConnectionAemEnvironmentConnection().finally(() => {
      store.once(aemEnvironmentConnectionName, (state) => {
        resolve(state);
      });
    });
  });

/* istanbul ignore next */
export const isMockServer = () =>
  ['localhost', 'dcp-local.mercedes-benz.com'].includes(window.location.hostname) &&
  window.location.pathname.startsWith('/serve');

export interface DialogParameters {
  isOpenOnStart: boolean;
  isRequired: boolean;
}
